import React, { Component } from 'react';

import BrandItem from './BrandItem';

import './style.css';

export class Brands extends Component {
   render() {
      return (
         <div className='brand_component _container'>
            {this.props.brands.map(el => (
               <BrandItem key={el.id} item={el} />
            ))}
         </div>
      )
   }
}

export default Brands

